export default "__VITE_ASSET__BjBP48Jj__"